"use strict";
/**
 * THE direction-aware tone rule for "spent vs plan" indicators (BEN-141 4b, F2).
 *
 * Moved here from `frontend/src/lib/planTone.ts` so mobile reads the same rule
 * rather than a third copy (DASH-S01). Web's copy stays until a web PR re-exports
 * this one; the two must not drift, which is the defect this module exists to end.
 *
 * The principle: never treat saving more as a problem, never treat overspending
 * as fine.
 *
 *   - FUNDING buckets (savings, splash, debt): money moved somewhere it should
 *     go. Past plan is GOOD.
 *   - SPENDING buckets (needs, wants) and the WHOLE-PERIOD plan: money leaving.
 *     Past plan is BAD.
 *   - Exactly ON plan is good for everything. Only PAST plan carries a direction.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.planTone = planTone;
exports.isOverspent = isOverspent;
/** Buckets where exceeding the plan means the user did something right. */
const OVER_PLAN_IS_GOOD = {
    savings: true,
    "splash-fund": true,
    splash: true,
    debt: true,
    "debt-allocation": true,
    needs: false,
    wants: false,
    flexible: false,
    bills: false,
    // A whole pay period is spending-shaped: past plan means more money left.
    period: false,
};
function planTone({ id, percentUsed, hasPlan = true }) {
    if (!hasPlan)
        return "neutral";
    if (percentUsed > 100)
        return (OVER_PLAN_IS_GOOD[id] ?? true) ? "good" : "over";
    if (percentUsed >= 100)
        return "good";
    return "neutral";
}
/** True when past plan in the BAD direction: the case that must never read as done. */
function isOverspent(input) {
    return planTone(input) === "over";
}
//# sourceMappingURL=planTone.js.map